(() => {
  if (window.EuroguardTestingStore) return;
  const defaults = [{"id":"classic","name":"Classic Carbon","tm":""},{"id":"tripure","name":"TriPure™","tm":""},{"id":"triceraflow","name":"TriCera Flow™","tm":""},{"id":"tricerafluor","name":"TriCera™ Fluoride","tm":""},{"id":"ceracore","name":"CeraCore™","tm":""},{"id":"undercounter","name":"Under-counter","tm":""}];
  const getCarts = () => {
    const buttons = [...document.querySelectorAll('testing-cartridge-picker [data-cartridge]')];
    return buttons.length ? buttons.map((button) => ({ id: button.dataset.cartridge, name: button.querySelector('strong')?.textContent.trim() || button.dataset.cartridge, tm: '' })) : defaults;
  };
  const data = { get carts() { return getCarts(); }, categories: [], rows: [], proto: {} };
  const requested = new URLSearchParams(window.location.search).get('cartridge');
  let selected = getCarts().some((c) => c.id === requested) ? requested : getCarts()[0].id;
  window.EuroguardTestingStore = {
    data,
    get cartridge() { return getCarts().some((c) => c.id === selected) ? selected : getCarts()[0].id; },
    getCartridge(id) { return getCarts().find((c) => c.id === (id || this.cartridge)) || getCarts()[0]; },
    selectCartridge(id) {
      if (!getCarts().some((c) => c.id === id) || selected === id) return;
      selected = id;
      window.dispatchEvent(new CustomEvent('euroguard:testing-cartridge-change', { detail: { cartridge: id } }));
    }
  };
  document.addEventListener('shopify:section:load', () => {
    window.dispatchEvent(new CustomEvent('euroguard:testing-cartridge-change', { detail: { cartridge: window.EuroguardTestingStore.cartridge } }));
  });
})();
